import { Suspense } from 'react';
import Loading from 'components/loading';
import Header from '../components/header';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const AppLayout = () => {
  return (
    <Box>
      <Header />
      <Suspense fallback={<Loading style={{ height: '100vh' }} />}>
        <Outlet />
      </Suspense>
    </Box>
  );
};

export default AppLayout;
